module.exports = require("@lingui/core");